module.exports = __webpack_public_path__ + "img/background.6a802e43.jpg";